module.exports = __webpack_public_path__ + "img/image21.25a4c767.png";